import { API_UNAUTHORIZED_ERROR } from 'actions/api';
import {
  BOOTSTRAP_DASHBOARD,
  BOOTSTRAP_DASHBOARD_ERROR,
  BOOTSTRAP_DASHBOARD_SUCCESS,
} from 'actions/dashboard';

import {
  BOOTSTRAP_DASHBOARD_V3,
  BOOTSTRAP_DASHBOARD_V3_ERROR,
  BOOTSTRAP_DASHBOARD_V3_SUCCESS,
} from 'lib/constants/v3Actions';

const initialState = {
  initializationComplete: false,
  legacyInitializationComplete: false,
  isUnauthorized: false,
  needsInitializing: true,
  legacyNeedsInitializing: true,
};

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case BOOTSTRAP_DASHBOARD:
      return { ...state, legacyNeedsInitializing: false };

    case BOOTSTRAP_DASHBOARD_ERROR:
      return { ...state, legacyNeedsInitializing: true };

    case BOOTSTRAP_DASHBOARD_SUCCESS:
      return { ...state, legacyInitializationComplete: true };

    case BOOTSTRAP_DASHBOARD_V3:
      return { ...state, needsInitializing: false };

    case BOOTSTRAP_DASHBOARD_V3_ERROR:
      return { ...state, needsInitializing: true };

    case BOOTSTRAP_DASHBOARD_V3_SUCCESS:
      return { ...state, initializationComplete: true };

    case API_UNAUTHORIZED_ERROR:
      return { ...state, isUnauthorized: true };

    default:
      return state;
  }
};

export const isInitializationComplete = state => state.initializationComplete;
export const needsInitializing = state => state.needsInitializing;
export const legacyNeedsInitializing = state => state.legacyNeedsInitializing;
export const isUnauthorized = state => state.isUnauthorized;
